import React from 'react'

import Navigation from '../components/common/Navigation'
import Portfolio from '../components/pages/portfoliopage/Portfolio';
import Footer from '../components/common/Footer'

const PortfolioPage = () => {
  return (
    <div id='PortfolioPage'>
      <Navigation />
      <Portfolio />
      <Footer />
    </div>
  )
}

export default PortfolioPage